import React, { useEffect, useRef } from "react";

import { ButtonTabsPropType } from "@models/components/formElements.model";
import { ResourceInfoType } from "@models/components/units.model";
import { locationType } from "@models/services/organisation";
import { applyLocalization } from "@services/common.service";

const ButtonTabs: React.FC<ButtonTabsPropType> = ({
  handleTabChange,
  selectedTab,
  tabs,
}) => {
  const selectedTabRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (selectedTabRef.current) {
      selectedTabRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedTab]);

  const getClassName = (resourceId: string) => {
    return selectedTab === resourceId ? "fg-loc-active" : "";
  };
  return (
    <ul className="fg-loc-scroll" data-testid="buttonTabs">
      {tabs?.map((tab: ResourceInfoType | locationType, index: number) => (
        <li
          aria-hidden={true}
          className={getClassName(
            (tab as ResourceInfoType)?.id || (tab as locationType)?.id
          )}
          data-testid="buttonTab"
          key={index}
          onClick={() => handleTabChange(tab)}
          ref={
            selectedTab ===
            ((tab as ResourceInfoType)?.id || (tab as locationType)?.id)
              ? selectedTabRef
              : null
          }
        >
          <h2 className="my-0">
            <button> {applyLocalization(tab?.info?.title)}</button>
          </h2>
        </li>
      ))}
    </ul>
  );
};

export default ButtonTabs;
